import { Link } from "react-router-dom";

const heroStats = [
  { value: "128", label: "今日新增话题" },
  { value: "46", label: "当前在榜话题" },
  { value: "2h", label: "榜单刷新间隔" },
];

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20stylized%20entertainment%20news%20collage%20with%20deep%20charcoal%20background%20and%20glowing%20warm%20orange%20amber%20light%20streaks%20artistic%20editorial%20texture%20dark%20moody%20cinematic&width=1600&height=900&seq=gua-hero-bg-01&orientation=landscape"
          alt="黑料瓜网娱乐热点资讯门户视觉背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/80 via-secondary-950/70 to-secondary-950/85"></div>
      </div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-3 py-1 font-label text-xs font-bold text-secondary-950">
            <i className="ri-time-line h-4 w-4 flex items-center justify-center"></i>
            今日瓜 · 实时刷新
          </span>
          <h1 className="mt-5 font-heading text-4xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
            黑料瓜网
          </h1>
          <p className="mt-4 max-w-2xl font-heading text-lg font-semibold text-accent-200 md:text-2xl">
            今日瓜持续更新，热门大瓜、新瓜速递一网打尽
          </p>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            吃瓜榜单实时刷新，热议话题不错过。想快速掌握最新的娱乐热议动态，点开这里就能看到大家都在讨论什么，吃瓜不迷路。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/rank"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-list-check h-4 w-4 flex items-center justify-center"></i>
              进入吃瓜榜单
            </Link>
            <a
              href="#hot"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 bg-background-50/10 px-6 py-3 font-label text-sm font-bold text-background-50 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-fire-line h-4 w-4 flex items-center justify-center"></i>
              浏览热门话题
            </a>
          </div>
        </div>

        <dl className="mt-12 grid max-w-2xl grid-cols-1 gap-4 border-t border-background-100/20 pt-6 sm:grid-cols-3">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex flex-col">
              <dt className="font-label text-xs text-background-200">{stat.label}</dt>
              <dd className="mt-1 font-heading text-3xl font-black text-accent-300">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}